import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import Tooltip from '@/tooltip';
import { Actions as ALLOWANCEACTIONS } from "@/redux/actions/allowanceActions";
import AllowanceTypeOption from "@/components/company-settings/allowance-tab/AllowanceTypeOption.json";


const TaxableOption = [
    { label: 'Pre Tax (yes)', value: 1 },
    { label: 'Post Tax (no)', value: 0 },
];

const AdvancedAllowance = ({
    allowance, 
    updateSetting, 
    disabled,
    jurisdiction,
    allowanceTypeOptions
}) => {

    const payItemWord = jurisdiction == 'UK' ? 'Pay Item' : 'Allowance'

    return (
        <React.Fragment>
            <div className='col-xs-12 pr-0 pl-0' style={{ marginBottom: 15 }}>
                <h5>Basic {payItemWord} Options</h5>
            </div>
            <div className="col-xs-5" style={{ paddingLeft: 0 }}>
                <div className="form-material">
                    <input
                        id="allowance-type-name"
                        className="form-control valid form-input"
                        type="text"
                        name="name"
                        autoComplete="off"
                        onChange={(e) => updateSetting(allowance.id, e.target.name, e.target.value)}
                        defaultValue={allowance.name}
                        disabled={disabled}
                    />
                    <label htmlFor="material-text">Name</label>
                </div>

            </div>

            <div className={`col-xs-${jurisdiction == "UK" ? '7' : '3'}`}>
                <div className="form-material">
                    <Select
                        valueName="selected"
						options={allowanceTypeOptions}
                        value={AllowanceTypeOption.find((t) => t.value == allowance.methodId)}
                        placeholder="Choose one"
                        isDisabled={disabled}
                        onChange={(e) => {
                            updateSetting(allowance.id, "method", e.label)
                            updateSetting(allowance.id, "methodId", e.value)
                        }}
                    />
                    <label htmlFor="example2-select2">Type</label>
                    <div className="clearfix" />
                </div>
            </div>

            <div className={`col-xs-${jurisdiction == "UK" ? '12 pr-0 pl-0' : '4'}`}>
                <div className={`col-xs-${jurisdiction == "UK" ? '2 pl-0' : '4'}`}>
                    <Tooltip content={`Tick if this ${jurisdiction == 'UK' ? 'pay item' : 'allowance'} is taxable ${jurisdiction == 'UK' ? 'and not a benefit' : ''}`}>
                        <label htmlFor="taxable" style={{ marginBottom: 0 }}>Taxable</label>
                    </Tooltip>
                </div>

                {jurisdiction == "UK" &&
                    <>
                        <div className="col-xs-2 pl-0">
                            <Tooltip content='Tick if NIC has to be deducted on this pay item'>
                                <label htmlFor="nicable" style={{ marginBottom: 0 }}>Nicable</label>
                            </Tooltip>
                        </div>
                        <div className="col-xs-2 pl-0">
                        <Tooltip content="Tick if Pension is to be deducted on this pay item - this only impacts pensions based on the Employee's pension plan">
                                <label htmlFor="pensionable" style={{ marginBottom: 0 }}>Pensionable</label>
                            </Tooltip>
                        </div>
                        <div className="col-xs-2 pl-0">
                            <Tooltip content='Tick if this is a taxable benefit'>
                                <label htmlFor="nicable" style={{ marginBottom: 0 }}>Benefit</label>
                            </Tooltip>
                        </div>
                        <div className="col-xs-2 pl-0">
                        <Tooltip content="Tick if benefit is subject to NIC 1A">
                                <label htmlFor="pensionable" style={{ marginBottom: 0 }}>NIC 1A</label>
                            </Tooltip>
                        </div>
                    </>
                }
            </div>

            <div className={`col-xs-${jurisdiction == "UK" ? '12 pr-0 pl-0' : '4'}`}>
                <div className={`col-xs-${jurisdiction == "UK" ? '2 pl-0' : '4'}`}>
                    <label className="css-input switch switch-sm switch-success">
                        <input
                            id="taxable"
                            type="checkbox"
                            checked={!!allowance.taxable}
                            onChange={() => updateSetting(allowance.id, "taxable", !allowance.taxable)}
                        />
                        <span></span>
                    </label>
                </div>

                {jurisdiction == "UK" &&
                    <>
                        <div className="col-xs-2 pl-0">
                            <label className="css-input switch switch-sm switch-success">
                                <input
                                    id="nicable"
                                    type="checkbox"
                                    checked={!!allowance.nicable}
                                    onChange={() => updateSetting(allowance.id, "nicable", !allowance.nicable)}
                                />
                                <span></span>
                            </label>
                        </div>

                        <div className="col-xs-2 pl-0">
                            <label className="css-input switch switch-sm switch-success">
                                <input
                                    id="pensionable"
                                    type="checkbox"
                                    checked={!!allowance.pensionable}
                                    onChange={() => updateSetting(allowance.id, "pensionable", !allowance.pensionable)}
                                />
                                <span></span>
                            </label>
                        </div>

                        <div className="col-xs-2 pl-0">
                            <label className="css-input switch switch-sm switch-success">
                                <input
                                    id="benefits"
                                    type="checkbox"
                                    checked={!!allowance.benefits}
                                    onChange={() => updateSetting(allowance.id, "benefits", !allowance.benefits)}
                                />
                                <span></span>
                            </label>
                        </div>

                        <div className="col-xs-2 pl-0">
                            <label className="css-input switch switch-sm switch-success">
                                <input
                                    id="nic1A"
                                    type="checkbox"
                                    checked={!!allowance.nic1A}
                                    onChange={() => updateSetting(allowance.id, "nic1A", !allowance.nic1A)}
                                />
                                <span></span>
                            </label>
                        </div>
                    </>
                }
            </div>

            <div className='col-xs-12 pr-0 pl-0' style={{ marginTop: 20 }}>
                <div className='col-xs-12 pr-0 pl-0' style={{ marginBottom: 15 }}>
                    <h5>Advanced {payItemWord} Options</h5>
                </div>

                <div className="col-xs-6 pl-0">
                    <label className="css-input switch switch-sm switch-success">
                        <input
                            id="salaryAllowanceFixed"
                            type="checkbox"
                            checked={!!allowance.salaryAllowanceFixed}
                            onChange={() => updateSetting(allowance.id, "salaryAllowanceFixed", !allowance.salaryAllowanceFixed)}
                        />
                        <span></span>
                        <Tooltip content={`Tick if this ${jurisdiction == 'UK' ? 'pay item' : 'allowance'} is always fixed`}>
                            <label htmlFor="salaryAllowanceFixed" style={{ marginBottom: 0 }}>Fixed {payItemWord}</label>
                        </Tooltip>

                    </label>
                </div>


                <div className="col-xs-6" style={{ paddingLeft: 0 }}>
                    <div className="form-material">
                        <input
                            className="form-control valid form-input"
                            type="text"
                            name="code"
                            autoComplete="off"
                            onChange={(e) => updateSetting(allowance.id, e.target.name, e.target.value)}
                            defaultValue={allowance.code}
                            disabled={disabled}
                        />
                        <label htmlFor="material-text">{payItemWord} Code</label>
                    </div>

                </div>
            </div>
        </React.Fragment>
    );
};
const mapStateToProps = (state, ownProps) => {

    const allowanceId = state.company?.advancedSettingsModal?.id
    const jurisdiction = state.company?.settings?.jurisdiction

    return {
		allowanceTypeOptions: AllowanceTypeOption.filter((t) => t.jurisdiction.includes(jurisdiction)),
        jurisdiction,
        allowance: state.company?.settings?.allowances?.find(allowance => allowance.id == allowanceId)
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateSetting: (id, field, newValue) => dispatch(ALLOWANCEACTIONS.updateSetting(id, field, newValue, false)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdvancedAllowance)